import { Link } from "react-router-dom";
import { LESSONS } from "../data/lessons";
import { useEffect, useState } from "react";
import { Check } from "lucide-react";

const STORAGE_KEY = "ao_lesson_complete";

export default function LessonsIndex() {
  const [complete, setComplete] = useState({});
  useEffect(() => {
    try {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
      setComplete(saved);
    } catch (_) { /* ignore */ }
  }, []);
  const doneCount = Object.values(complete).filter(Boolean).length;
  const pct = Math.round((doneCount / LESSONS.length) * 100);

  return (
    <div className="max-w-[1400px] mx-auto px-6 py-16 lg:py-24" data-testid="lessons-page">
      <div className="eyebrow">Reading</div>
      <h1 className="mt-6 font-serif text-5xl lg:text-6xl text-[#1A1915] leading-[0.95]">12 Lessons</h1>
      <p className="mt-6 max-w-2xl text-base text-[#1A1915] leading-relaxed">
        Sequential essays on the theory that underpins the diagnostic. Read in order — each lesson ends with a closing impulse. Mark them complete as you go.
      </p>

      {/* Progress */}
      <div className="mt-10 border border-[#1A1915] p-4 max-w-md" data-testid="lessons-progress">
        <div className="flex items-center justify-between text-xs uppercase tracking-widest text-[#78716C]">
          <span>Your progress</span>
          <span className="text-[#1A1915] font-semibold">{doneCount} / {LESSONS.length}</span>
        </div>
        <div className="mt-3 h-1 bg-[#1A1915]/10">
          <div className="h-full bg-[#B8863C] transition-all duration-150" style={{ width: `${pct}%` }} />
        </div>
      </div>

      {/* Grid */}
      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0 border border-[#1A1915]">
        {LESSONS.map((l, i) => {
          const done = !!complete[l.slug];
          const colInRow = i % 3;
          const isLastInRow = colInRow === 2;
          const isTopRow = i < 3;
          return (
            <Link
              to={`/lessons/${l.slug}`}
              key={l.slug}
              data-testid={`lesson-card-${l.slug}`}
              className={`group block p-8 relative ${!isLastInRow ? "lg:border-r border-[#1A1915]" : ""} ${!isTopRow ? "lg:border-t border-[#1A1915]" : ""} ${i > 0 ? "border-t lg:border-t-0 border-[#1A1915]" : ""} hover:bg-[#F5F5F4] transition-colors duration-150`}
            >
              {done && (
                <div className="absolute top-4 right-4 flex items-center gap-1 text-xs text-[#B8863C] uppercase tracking-widest font-semibold">
                  <Check className="w-3 h-3" strokeWidth={2} /> Done
                </div>
              )}
              <div className="eyebrow">Chapter {String(l.n).padStart(2, "0")}</div>
              <h2 className="mt-3 font-serif text-2xl text-[#1A1915] leading-tight">{l.title}</h2>
              <p className="mt-3 text-sm italic text-[#78716C] leading-relaxed">{l.teaser}</p>
              <div className="mt-6 text-xs uppercase tracking-widest text-[#1A1915] group-hover:translate-x-1 transition-transform duration-150 inline-block">Read →</div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
